import firebase from 'firebase';

const config = {
    apiKey: "AIzaSyDx3eI3u_-5VaZc-6MGNWgbnJvwyD1Hv64",
    authDomain: "stylish-discussion-battle.firebaseapp.com",
    databaseURL: "https://stylish-discussion-battle.firebaseio.com",
    projectId: "stylish-discussion-battle",
    storageBucket: "stylish-discussion-battle.appspot.com",
    messagingSenderId: "274573805508",
    appId: "1:274573805508:web:7698fc1d036dd4d87e4691"
};

const firebaseApp = firebase.initializeApp(config);
export const firestore = firebaseApp.firestore();